import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { routerShape, withRouter } from 'react-router';
import { startsWith } from 'lodash';
import config from '../config';
import AppStore from '../stores/AppStore';
import AnalyticsActionCreator from '../actions/AnalyticsActionCreator';
import SiteHeaderUtil from '../utils/SiteHeaderUtils';

class BankApp extends Component {
  constructor(props) {
    super(props);

    this.onStoreChange = this.onStoreChange.bind(this);

    AnalyticsActionCreator.requestCheckLoopStart();

    this.state = {
      appData: AppStore.getAll(),
    };
  }

  componentDidMount() {
    AppStore.addChangeListener(this.onStoreChange);

    AnalyticsActionCreator.track({
      path: '/user/experience/lifecycle',
      action: 'Started',
    });
  }

  /**
   * Triggered on a state change.
   * Has the task ID changed? If so, navigate the user.
   * API Task IDs are separate to web task IDs so that we can reliably detect intentional changes.
   *
   * @param  {Object} prevProps
   * @param  {Object} prevState
   */
  componentDidUpdate(prevProps, prevState) {
    let newUrl;
    const prev = prevState.appData;
    const current = this.state.appData;

    if (prev.apiTaskId !== current.apiTaskId) {
      newUrl = current.apiTaskId;
    } else if (prev.webTaskId !== current.webTaskId) {
      newUrl = current.webTaskId;
    }
    const isHashNav = startsWith(this.props.location.hash, '#/');
    if (
      this.props.location.action === 'POP' &&
      !isHashNav &&
      prevState.appData.webTaskId
    ) {
      this.props.router.push(config.taskUrls['WEB-HOMEPAGE']);
      return;
    }

    /*
		Changes for BOW-2175
		Show the default browser offline page
		@ author Shubham
		*/
    if (navigator.onLine) {
      if (newUrl) {
        SiteHeaderUtil.isMenuClicked();
        this.props.router.push(config.taskUrls[newUrl]);
      } else {
        if (
          SiteHeaderUtil.isMenuClicked() &&
          prev.webTaskId === current.webTaskId
        ) {
          this.props.router.push(config.taskUrls['WEB-INTERMEDIATE']);
          setTimeout(() => {
            this.props.router.push(config.taskUrls[current.webTaskId]);
          }, 10);
        }
      }
    } else {
      window.onbeforeunload = null;
      window.location.reload();
    }
  }

  componentWillUnmount() {
    AppStore.removeChangeListener(this.onStoreChange);
  }

  onStoreChange() {
    this.setState({ appData: AppStore.getAll() });
  }

  render() {
    const { children, router, ...props } = this.props;
    const isHashNav = startsWith(this.props.location.hash, '#/');
    if (props.location.action === 'POP' && !isHashNav) {
      return null;
    }
    return (
      children &&
      React.cloneElement(children, {
        ...this.state,
        ...props,
      })
    );
  }
}

BankApp.propTypes = {
  children: PropTypes.node,
  router: routerShape,
};

export default withRouter(BankApp);
